import React from "react";
import RegistrationForm from "./RegistrationForm";
import NavigationBar from "../NavigationBar";

// Registration page.
const RegisterUser = () => {
    return (
        <div className="row">
            <NavigationBar/>
            <div className="d-none d-lg-block d-xl-block d-xxl-block col-lg-7 col-xl-7 col-xxl-7">
                <div className="wd-align-auto">
                    <h5><i>Food that makes soul happy!</i></h5>
                    <img src="./../images/food.jpg" className="rounded-pill"/>
                </div>
            </div>
            <div className="col-s-12 col-xs-12 col-md-12 col-lg-5 col-xl-5 col-xxl-5">

                <div className="list-group mt-2">
                    <h1>Register User</h1>
                    <RegistrationForm/>
                </div>

            </div>
        </div>
    );
};

export default RegisterUser;